export default __webpack_public_path__ + "static/media/twitter.56cecafb.svg";